module.exports = __webpack_public_path__ + "static/media/Template_20.8571b5c5.png";